import React from "react";
import { useOverrideCustomerFolderSyncMutation } from "../mutations.hotchoc.generated";
import { useSnackBar } from "~/components/snackbar";
import { useProjectFoldersPageApi } from "../ProjectFoldersPageApi";
import { OverrideSyncButtons } from "../components/OverrideSyncButtons";
import { CustomerFolder } from "../types";
import { handleResult } from "../utils";

type OverrideCustomerFolderSyncProps = {
  folder: CustomerFolder;
};

export const OverrideCustomerFolderSync: React.FC<
  OverrideCustomerFolderSyncProps
> = ({ folder }) => {
  const addAlert = useSnackBar();
  const { reload } = useProjectFoldersPageApi();
  const [handleOverride, { loading }] = useOverrideCustomerFolderSyncMutation();

  const handle = async (retry: boolean) => {
    const variables = {
      input: {
        folderId: folder.id,
        path: folder.path,
        retrySync: retry,
      },
    };

    const response = await handleOverride({ variables });

    const errors = handleResult(
      response.data!.projectFolders!.overrideCustomerFolderSync
    );

    if (errors) {
      addAlert({
        key: `failed-sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: errors,
        isSuccess: false,
      });
    } else {
      addAlert({
        key: `sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: `"${folder.path}" ${
          retry ? "queued for sync retry" : "sync status overridden"
        }`,
        isSuccess: true,
      });

      reload();
    }
  };

  return <OverrideSyncButtons loading={loading} handle={handle} />;
};
